import React from 'react';
import { CheckIcon, SunIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { trackPixelEvent } from '../hooks/useMetaPixel';
const includes = ['5 Tomos completos · Principiante → Experto', '5 Bonos estratégicos (valor $89 USD)', '100% PDF descargable · acceso de por vida'];
export function PricingSection() {
  return <section className="w-full scroll-mt-3 bg-ink-950 py-10 sm:py-16" id="precios" aria-labelledby="precios-title" data-id="element-158" data-mp="1jb1rabp9aq5n">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-159" data-mp="1s93yxa3hwh1w">
        <div className="text-center" data-id="element-160" data-mp="1sbq5p7ikasj2">
          <h2 id="precios-title" className="font-display text-2xl font-900 leading-tight text-white sm:text-4xl" data-id="element-161" data-mp="1x86wyal25n0d">
            Un solo pack. Todo incluido.
          </h2>
          <p className="mt-1.5 text-sm text-slate-400 sm:mt-3 sm:text-base" data-id="element-162" data-mp="2vh0bl3b1zpa">
            Acceso de por vida. Sin suscripciones. Sin letra pequeña.
          </p>
        </div>

        <div className="mt-5 rounded-2xl border border-gold bg-ink-900 p-5 shadow-panel sm:mt-8 sm:p-9" data-id="element-163" data-mp="1mgogxhl8plni">
          <div className="grid gap-4 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-8" data-id="element-164" data-mp="1hq80dom4hjwx">
            <div data-id="element-165" data-mp="1cqv5cgl3l6j9">
              <h3 className="font-display text-xl font-800 uppercase leading-tight tracking-wide text-white sm:text-3xl" data-id="element-166" data-mp="1cqbx5rl91wif">
                Código Solar 360°
              </h3>

              <ul className="mt-3 grid gap-1.5 sm:mt-5 sm:gap-2.5" data-id="element-167" data-mp="25fiskhpeq5zg">
                {includes.map(item => <li key={item} className="flex gap-2 text-sm leading-snug text-slate-200 sm:text-[15px] sm:leading-relaxed" data-id="element-168" data-mp="20gpgmtprqn1e">
                    <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-169" data-mp="1vgbji6ppgxi5" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex items-baseline justify-center gap-3 border-t border-ink-800 pt-4 sm:min-w-[220px] sm:flex-col sm:items-center sm:gap-0 sm:border-l sm:border-t-0 sm:pl-8 sm:pt-0 sm:text-center" data-id="element-170" data-mp="g0ugkhkqaq1y">
              <p translate="no" className="whitespace-nowrap text-base text-slate-500 line-through sm:text-lg" data-id="element-171" data-mp="mh4fpi8y44pq">
                $69&nbsp;USD
              </p>
              <p className="font-display text-4xl font-900 leading-none text-gold sm:mt-1 sm:text-6xl" data-id="element-172" data-mp="chvouy9dn67l">
                $14
              </p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 sm:mt-2 sm:text-xs" data-id="element-173" data-mp="3uul4wtbmpth2">
                USD · Pago único
              </p>
            </div>
          </div>

          <a href="https://codigo-solar-360.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          value: 17,
          currency: 'USD'
        })} className="mt-5 flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:mt-8 sm:py-4 sm:text-lg" data-id="element-174" data-mp="3l01i9bum01uu">
            <SunIcon className="h-5 w-5" aria-hidden="true" data-id="element-175" data-mp="2sdbk817ketc5" />
            Quiero mi Código Solar
          </a>
          <p className="mt-3 text-center text-xs text-slate-400 sm:mt-4 sm:text-[13px]" data-id="element-176" data-mp="36dckbeg09wqk">
            Garantía 7 días · Pago seguro · Acceso en 5 minutos
          </p>
        </div>

        <div className="mt-8 sm:mt-10" data-id="element-177" data-mp="3g8o4ica6nw5p">
          <Countdown label="Precio de lanzamiento — cierra en" note="Después sube el precio. No vuelve." progress={68} data-id="element-178" data-mp="3g7mff3wc194z" />
        </div>
      </div>
    </section>;
}